import { defineCustomElement } from 'vue'
import { register as registerSfUiComponents } from '@silverfin/ui-components'
import '@silverfin/ui-components/style.css'

import SfCeAiProposalContainer from '@app/shared/vue/custom-elements/ai-proposal/parent-container.ce.vue'
import SfCeAccordion from '@app/shared/vue/custom-elements/sf-accordion/sf-accordion.ce.vue'
import SfCeAccordionItem from '@app/shared/vue/custom-elements/sf-accordion/sf-accordion-item.ce.vue'
import SfCeDropdownWrapper from '@app/shared/vue/custom-elements/sf-dropdown/sf-dropdown-wrapper.ce.vue'
import SfCeToastRaiser from '../custom-elements/notifications/sf-toast-raiser.ce.vue'
import SfHeightWatcher from '@app/shared/vue/custom-elements/sf-height-watcher.ce.vue'
import SfDrawerToggle from '@app/shared/vue/custom-elements/sf-sidebar/sf-drawer-toggle.ce.vue'
import SfIndicatorNewComms from '@app/shared/vue/custom-elements/sf-sidebar/sf-indicator-new-comms.ce.vue'
import SfCeStaticPill from '@app/shared/vue/custom-elements/sf-static-pill/sf-static-pill.ce.vue'
import TooltipDirective from '@app/shared/vue/directives/tooltip'

export default () => {
  const SfCeAccordionElement = defineCustomElement(SfCeAccordion)
  const SfCeAccordionItemElement = defineCustomElement(SfCeAccordionItem)
  const SfCeAiProposalContainerElement = defineCustomElement(
    SfCeAiProposalContainer
  )
  const SfCeDrawerToggleElement = defineCustomElement(SfDrawerToggle, {
    configureApp(app) {
      app.directive('tooltip', TooltipDirective)
    },
  })
  const SfCeDropdownWrapperElement = defineCustomElement(SfCeDropdownWrapper)
  const SfCeHeightWatcherElement = defineCustomElement(SfHeightWatcher)
  const SfIndicatorNewCommsElement = defineCustomElement(SfIndicatorNewComms)
  const SfCeToastRaiserElement = defineCustomElement(SfCeToastRaiser)
  // No shadow root: the pill is Tailwind and Font Awesome classes, and the page's stylesheets
  // do not reach inside one. The label and icon come as attributes, not slot content.
  const SfCeStaticPillElement = defineCustomElement(SfCeStaticPill, {
    shadowRoot: false,
  })

  window.customElements.define('sf-ce-accordion', SfCeAccordionElement)
  window.customElements.define('sf-ce-accordion-item', SfCeAccordionItemElement)
  window.customElements.define(
    'sf-ce-ai-proposal-container',
    SfCeAiProposalContainerElement
  )
  window.customElements.define('sf-ce-drawer-toggle', SfCeDrawerToggleElement)
  window.customElements.define(
    'sf-ce-dropdown-wrapper',
    SfCeDropdownWrapperElement
  )
  window.customElements.define('sf-ce-height-watcher', SfCeHeightWatcherElement)
  window.customElements.define(
    'sf-ce-indicator-new-comms',
    SfIndicatorNewCommsElement
  )
  window.customElements.define('sf-ce-static-pill', SfCeStaticPillElement)
  window.customElements.define('sf-ce-toast-raiser', SfCeToastRaiserElement)
  registerSfUiComponents()
}
